import { sendGa } from 'reactApp/utils/ga';

export const moreAction = () => {
    sendGa('breadcrumbs', 'click');
};
